export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY'

export const DEFAULT_RAW_PER_PAGE_LOAD = [25, 50, 100]

export const DEFAULT_PER_PAGE_LOAD = DEFAULT_RAW_PER_PAGE_LOAD.map((opt) => ({
  token_id: `${opt}`,
  label: `${opt} per load`
}))

export const NO_BANK_CONNECTED = 'No bank connected'

export const PROGRAM_TYPES = [
  {
    token_id: 'no_program',
    label: 'No program'
  },
  {
    token_id: 'CPM',
    label: 'CPM'
  },
  {
    token_id: 'FAVR',
    label: 'FAVR'
  }
]

export const DEFAULT_MIN_ANNUAL_BUSINESS_MILES = 5000

export const MILES_KM_CONVERSION_NUMBER = 1.60934
